export default __webpack_public_path__ + "static/media/lock-icon.1fd90995.svg";